import { motion } from "framer-motion";
import { MapPin, Phone, Mail, FileBadge } from "lucide-react";

const rows = [
  {
    icon: MapPin,
    label: "Head Office",
    value: "Masjid Wali Gali 8, Takhatgarh, Pali, Rajasthan 306912",
    testid: "contact-address",
  },
  {
    icon: Phone,
    label: "Direct Line",
    value: "+91 80790 90643",
    href: "tel:+918079090643",
    testid: "contact-phone",
  },
  {
    icon: Mail,
    label: "Client Enquiries",
    value: "majisapowermanservice@gmail.com",
    href: "mailto:majisapowermanservice@gmail.com",
    testid: "contact-email-1",
  },
  {
    icon: Mail,
    label: "Admin Desk",
    value: "majisamanpower.admin@gmail.com",
    href: "mailto:majisamanpower.admin@gmail.com",
    testid: "contact-email-2",
  },
];

export const Contact = () => (
  <section id="contact" className="relative bg-[#0a0f1d] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#3b82f6] mb-4">Command Post</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase text-slate-100 leading-[0.95] mb-10">
          Talk to the <span className="text-[#d4af37]">Dispatch Desk</span>
        </h2>

        <div className="space-y-6">
          {rows.map((r, i) => (
            <motion.div
              key={r.testid}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
              className="flex items-start gap-4"
            >
              <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-white/10 bg-[#0d1424] rounded-sm">
                <r.icon className="w-4 h-4 text-[#d4af37]" />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{r.label}</p>
                {r.href ? (
                  <a data-testid={r.testid} href={r.href} className="text-base text-slate-100 font-medium hover:text-[#d4af37] transition-colors duration-300 break-all">
                    {r.value}
                  </a>
                ) : (
                  <p data-testid={r.testid} className="text-base text-slate-100 font-medium">{r.value}</p>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <span data-testid="contact-gstin" className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.15em] uppercase bg-white/5 border border-white/15 text-slate-300 px-3.5 py-2.5 rounded-sm">
            <FileBadge className="w-3.5 h-3.5 text-[#d4af37]" /> GSTIN: 08BXLPV7721E1Z1
          </span>
          <span data-testid="contact-pan" className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.15em] uppercase bg-white/5 border border-white/15 text-slate-300 px-3.5 py-2.5 rounded-sm">
            <FileBadge className="w-3.5 h-3.5 text-[#3b82f6]" /> PAN: BXLPV7721E1Z1
          </span>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <div className="absolute -inset-3 border border-[#d4af37]/25 rounded-sm" />
        <div className="relative overflow-hidden rounded-sm border border-white/10 h-[24rem] sm:h-[30rem]">
          <iframe
            data-testid="contact-map"
            title="Majisa Man Power Service — Takhatgarh, Pali"
            src="https://www.google.com/maps?q=Takhatgarh,+Pali,+Rajasthan+306912&output=embed"
            className="w-full h-full grayscale-[35%] contrast-[1.05]"
            loading="lazy"
          />
          <div className="absolute bottom-4 left-4 bg-[#0a0f1d]/90 backdrop-blur border border-white/10 px-4 py-3 rounded-sm">
            <p className="font-display text-lg font-bold uppercase text-slate-100 leading-none">Takhatgarh, Pali</p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-400 mt-1">Rajasthan · 306912</p>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
